import React from "react";
import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { IconMapPin } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";

interface MxCPropertyLocationProps {
  location: string;
}

const MxCPropertyLocation = React.memo(({ location }: MxCPropertyLocationProps) => {
  return (
    <Grid container columnSpacing={0.5} flexWrap="nowrap" alignItems="center">
      <Grid item xs="auto" width={10} ml={-0.5}>
        <MxIcons
          color="error.main"
          children={<IconMapPin size={16} stroke={1.5} />}
        />
      </Grid>
      <Grid item xs={11}>
        <MxTypography variant="overline" color="primary.main" lines={1}>
          {location}
        </MxTypography>
      </Grid>
    </Grid>
  );
});

MxCPropertyLocation.displayName = "MxCPropertyLocation";

export default MxCPropertyLocation;
